import { render, staticRenderFns } from "./GetFactory.vue?vue&type=template&id=ef44ab7e&scoped=true"
import script from "./GetFactory.vue?vue&type=script&lang=js"
export * from "./GetFactory.vue?vue&type=script&lang=js"
import style0 from "./GetFactory.vue?vue&type=style&index=0&id=ef44ab7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef44ab7e",
  null
  
)

export default component.exports